import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { createPageUrl } from "../utils"; 

export default function SuccessPage() {
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center px-4 py-8"
      dir="rtl"
      style={{ 
        fontFamily: 'Cairo, sans-serif',
        backgroundColor: '#e8e9eb'
      }}
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-20 left-10 w-48 h-48 rounded-full opacity-5 blur-2xl"
          style={{ backgroundColor: '#ee9805' }}
        />
        <div 
          className="absolute bottom-20 right-10 w-64 h-64 rounded-full opacity-5 blur-2xl"
          style={{ backgroundColor: '#141d3c' }}
        />
      </div>

      {/* Main Card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="relative bg-white rounded-2xl shadow-xl p-8 md:p-10 max-w-md w-full text-center"
      >
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.1, duration: 0.4 }}
          className="mb-6"
        >
          <img 
            src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/user_69492a6d14115650dc6c3e8d/07047b9eb_image.png"
            alt="زان"
            className="w-16 h-16 mx-auto object-contain"
          />
        </motion.div>

        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ 
            delay: 0.2, 
            type: "spring", 
            stiffness: 250, 
            damping: 20 
          }}
          className="mb-5"
        >
          <div 
            className="w-16 h-16 rounded-full mx-auto flex items-center justify-center"
            style={{ backgroundColor: 'rgba(238, 152, 5, 0.12)' }}
          >
            <CheckCircle2 
              className="w-9 h-9"
              style={{ color: '#ee9805' }}
              strokeWidth={2.5}
            />
          </div>
        </motion.div>

        {/* Success Message */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.4 }}
        >
          <h1 
            className="text-xl md:text-2xl font-bold mb-3"
            style={{ color: '#141d3c' }}
          >
            تم إرسال طلبك بنجاح
          </h1>
          <p 
            className="text-base leading-relaxed mb-7"
            style={{ color: '#141d3c', opacity: 0.65 }}
          >
            سيتم التواصل معك من قبل فريق زان في أقرب وقت
          </p>
        </motion.div>

        {/* Return Button */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.4 }}
        >
          <Link to="/">
  <button
    className="w-full py-5 text-base font-semibold rounded-lg bg-[#141d3c] text-white transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
    style={{ fontFamily: 'Cairo, sans-serif' }}
  >
    العودة للصفحة الرئيسية
  </button>
</Link>

        </motion.div>

        {/* Decorative line */}
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="mt-7 h-0.5 rounded-full mx-auto w-16"
          style={{ backgroundColor: '#ee9805', opacity: 0.4 }}
        />
      </motion.div>
    </div>
  );
}
